module.exports = __webpack_public_path__ + "static/media/navbar-ico-2-active.0f91842a.svg";